import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);
import store from "@/store";
// const routerPush = Router.prototype.push

// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }

import dashboard from "@/views/dashboard/index";
import login from "@/views/login";

/* layout */
import layout from "../views/layout/layout";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },

    {
      path: "/",
      redirect: "/system/parnerTarget",
      component: layout,
      name: "合伙人目标",
      children: [
        {
          path: "/system/parnerTarget",
          component: _import("system/parnerTarget"),
          name: "合伙人目标"
        }
      ]
    },
    {
      path: "/major",
      component: layout,
      name: "计划管理",
      children: [
        {
          path: "/plan/yearPlan",
          component: _import("plan/yearPlan"),
          name: "年计划管理"
        },
        {
          path: "/plan/monthPlan",
          component: _import("plan/monthPlan"),
          name: "月计划管理"
        },
        {
          path: "/plan/yearPlanDetail",
          name: "年计划详情",
          component: _import("plan/yearPlanDetail")
        },
        {
          path: "/plan/monthPlanDetail",
          name: "月计划详情",
          component: _import("plan/monthPlanDetail")
        }
      ]
    },
    {
      path: "/major",
      component: layout,
      name: "行为管理",
      children: [
        {
          path: "/behavior/behaviorList",
          component: _import("behavior/behaviorList"),
          name: "行为列表"
        }
      ]
    },
    {
      path: "/major",
      component: layout,
      name: "总结管理",
      children: [
        {
          path: "/summary/summaryList",
          component: _import("summary/summaryList"),
          name: "总结管理"
        }
      ]
    },
    {
      path: "/major",
      component: layout,
      name: "系统设置",
      children: [
        {
          path: "/behavior/behaviorSortList",
          component: _import("behavior/behaviorSortList"),
          name: "行为分类管理"
        },
        {
          path: "/system/weightSet",
          component: _import("system/weightSet"),
          name: "权重设置"
        }
      ]
    }
  ]
});

//路由导航配置
// router.beforeEach((to,from,next)=>{
//    //没有登录不让访问页面
//    if(to.path=="/"){
//      //访问登录页面放行
//      next()
//    }

//    if(sessionStorage.getItem("user")&&sessionStorage.getItem("token")){
//      //session里面有用户数据 说明登录过了
//      next()
//    }else{

//      next("/")
//    }

// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js